import each from 'lodash/each';

export class TabsNavigation {
  static init({ contents, images, tabs, deviceImages }) {
    return new TabsNavigation({ contents, images, tabs, deviceImages });
  }

  constructor({ contents, images, tabs, deviceImages }) {
    this.contents = contents;
    this.images = images;
    this.deviceImages = deviceImages;
    this.tabs = tabs;

    this.initFirstTab();
    this.registerActions(this.tabs.elements);
  }

  initFirstTab() {
    const INDEX_OF_TAB = 0;
    this.changeActiveClass(INDEX_OF_TAB, 'add');
  }

  changeActiveClass(indexOfTab, method) {
    if (this.contents.elements[indexOfTab]) {
      this.contents.elements[indexOfTab].classList[method](this.contents.activeClass);
    }

    if (this.deviceImages) {
      this.deviceImages.elements[indexOfTab].classList[method](this.deviceImages.activeClass);
    }

    if (this.images) {
      this.images.elements[indexOfTab].classList[method](this.images.activeClass);
    }

    if (this.contents.elements[indexOfTab]) {
      this.tabs.elements[indexOfTab].classList[method](this.tabs.activeClass);
    }
  }

  registerActions(elements) {
    const navElement = document.getElementById('tabs__wrapper');
    const isRtl = document.getElementsByTagName('html')[0].getAttribute('text-direction') === 'rtl';

    each(elements, tab => {
      tab.addEventListener('click', event => {
        const indexOfTab = Number(event.target.getAttribute('data-index'));
        each(this.tabs.elements, (tabElement, index) => this.changeActiveClass(index, 'remove'));

        if (indexOfTab === 0) {
          navElement.scrollLeft = isRtl ? navElement.firstElementChild.clientWidth : 0;
        }

        if (indexOfTab === elements.length - 1) {
          navElement.scrollLeft = isRtl ? 0 : navElement.firstElementChild.clientWidth;
        }

        this.changeActiveClass(indexOfTab, 'add');
      });
    });
  }
}
